import { render, staticRenderFns } from "./Sky.vue?vue&type=template&id=3dffbf9d&scoped=true&"
import script from "./Sky.vue?vue&type=script&lang=js&"
export * from "./Sky.vue?vue&type=script&lang=js&"
import style0 from "./Sky.vue?vue&type=style&index=0&id=3dffbf9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dffbf9d",
  null
  
)

export default component.exports